export default {
  mounted() {
    var requested_page = parseInt(this.$route.params.page)
    this.canProgressToPage(requested_page)
  },
  data() {
    return {
      currentPage: null
    }
  },
  watch: {
    '$route.params.page': {
      handler(requested_page) {
        if (this.records.progress) {
          this.currentPage = parseInt(this.getRequestedPage(requested_page))
          if (this.records && requested_page != this.currentPage) this.redirectPage(this.currentPage);
        }
      },
      immediate: true
    },
    'records.progress': {
      handler(progress) {
        var requested_page = parseInt(this.$route.params.page)
        this.currentPage = this.getRequestedPage(requested_page)
        if (this.records && requested_page != this.currentPage) this.redirectPage(this.currentPage);
      }
    }
  },
  computed: {
    lastPage() {
      if (this.pages.length) {
        var lastpage = this.pages[this.pages.length - 1].number
        if (lastpage == this.currentPage) return true;
        return false;
      }
    },
    canProgressToNextPage() {
      return this.canProgressToPage(this.currentPage + 1)
    },
    // pagename() {
    //   if (this.pages)
    //     return this.pages[this.currentPage];
    // },
  },
  methods: {
    redirectPage(allowed) {
      var route = { name: this.$route.name, params: this.$route.params }
      route.params.page = allowed
      this.$router.replace(route)
    },
    gotoNextPage() {
      var route = { name: this.$route.name, params: this.$route.params }
      var index = _.findIndex(this.pages, (page) => this.currentPage == page.number)
      var newPage = this.pages[index + 1].number
      if (this.pages[index + 1]) {
        if (this.canProgressToPage(newPage)) {
          var page = this.getRequestedPage(newPage)
          route.params.page = page
          this.$router.replace(route)
          this.currentPage = parseInt(page)
          window.scrollTo(0, 0)
        }
      }
    },
    gotoPrevPage() {
      var route = { name: this.$route.name, params: this.$route.params }
      var index = _.findIndex(this.pages, (page) => this.currentPage == page.number)
      var newIndex = index - 1;
      if (newIndex > -1 && this.pages[newIndex]) {
        var newPage = this.pages[newIndex].number
        if (this.canProgressToPage(newPage)) {
          var page = this.getRequestedPage(newPage)
          route.params.page = page
          this.$router.replace(route)
          this.currentPage = parseInt(page)
          window.scrollTo(0, 0)
        }
      }
    },
    updateProgress() {
      var index = _.findIndex(this.pages, (page) => this.currentPage == page.number)
      var progress = this.pages[index].number
      if (this.pages[index + 1]) progress = this.pages[index + 1].number
      this.records.progress = this.records.progress < progress ? progress : this.records.progress
    },
    getRequestedPage(requested_page) {
      var progress = (this.records != null && this.records.progress != null) ? this.records.progress : 1
      return this.canProgressToPage(requested_page) ? requested_page : progress
    },
    canProgressToPage(requested_page) {
      if (this.records) {
        if(this.records.id) return true;
        var progress = (this.records != null && this.records.progress != null) ? this.records.progress : 1
        return requested_page <= progress
      }
      // return false
    },
  }
}
